import favoriteComponentsWithIsReadonlySelector from 'app/Can/selectors/favoriteComponentsWithIsReadonly';
import isPageSelectedSelector from 'app/Page/selectors/isPageSelected';
import cwdDetailsSelector from 'app/Tree/selectors/cwdDetails';
import favoritePagesSelector from 'app/UserInfo/selectors/favoritePages';
import { toggleFavoriteContentThunk } from 'app/UserInfo/thunks';
import connect from 'utils/store/connect';

import ComponentSearch from './components/ComponentSearch';
import {
  addDuplicateComponentToContainerThunk,
  addDuplicateComponentToPageThunk,
  addMasterComponentToPageThunk,
  checkStatusAndDuplicateComponentThunk,
  checkStatusAndSwitchToComponentThunk,
  deleteComponentThunk,
  getComponentAndExecuteFunctionThunk
} from './thunks';

/**
 * maps redux state to component props
 * @param {object} state - the current state
 * @returns {object} properties of state to be mapped to this component's props
 */
const mapStateToProps = state => ({
  cwdDetails: cwdDetailsSelector(state),
  favoriteComponents: favoriteComponentsWithIsReadonlySelector(state),
  favoritePages: favoritePagesSelector(state),
  isPageSelected: isPageSelectedSelector(state)
});

const mapDispatchToProps = {
  addDuplicateComponentToContainer: addDuplicateComponentToContainerThunk,
  addDuplicateComponentToPage: addDuplicateComponentToPageThunk,
  addMasterComponentToPage: addMasterComponentToPageThunk,
  createDuplicateComponent: checkStatusAndDuplicateComponentThunk,
  deleteComponent: deleteComponentThunk,
  getComponentAndExecuteFunction: getComponentAndExecuteFunctionThunk,
  switchToComponent: checkStatusAndSwitchToComponentThunk,
  toggleFavoriteContent: toggleFavoriteContentThunk
};

export default connect(mapStateToProps, mapDispatchToProps)(ComponentSearch);
